import * as React from 'react';
import {Redirect} from 'react-router-dom';

import {EmailPage} from '../../ui/email/email-page';

type Props = {
    ticketMessageId: string | null | undefined;
};

export function TicketMessageRoot(props: Props) {
    if (!props.ticketMessageId) {
        return <Redirect to='/sales/dashboard' />;
    }

    return <EmailPage emailId={props.ticketMessageId} isTicketMessage={true} />;
}
